// extracted by mini-css-extract-plugin
export default {"titleRow":"Cg0mRm2FRcOL4tVLuOXZ"};